import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import useFeatureStore from "./store/useFeatureStore";

import en from "./locales/en/translation.json";
import ar from "./locales/ar/translation.json";
import ml from "./locales/ml/translation.json";
import es from "./locales/es/translation.json";
import sq from "./locales/sq/translation.json";
import am from "./locales/am/translation.json";
import az from "./locales/az/translation.json";
import eu from "./locales/eu/translation.json";
import bn from "./locales/bn/translation.json";
import bs from "./locales/bs/translation.json";
import bg from "./locales/bg/translation.json";
import my from "./locales/my/translation.json";
import ca from "./locales/ca/translation.json";
import zh from "./locales/zh/translation.json";
import hr from "./locales/hr/translation.json";
import cs from "./locales/cs/translation.json";
import da from "./locales/da/translation.json";
import nl from "./locales/nl/translation.json";
import et from "./locales/et/translation.json";
import fi from "./locales/fi/translation.json";
import fr from "./locales/fr/translation.json";
import gl from "./locales/gl/translation.json";
import ka from "./locales/ka/translation.json";
import de from "./locales/de/translation.json";
import el from "./locales/el/translation.json";
import gu from "./locales/gu/translation.json";
import he from "./locales/he/translation.json";
import hi from "./locales/hi/translation.json";
import hu from "./locales/hu/translation.json";
import id from "./locales/id/translation.json";
import it from "./locales/it/translation.json";
import ja from "./locales/ja/translation.json";
import km from "./locales/km/translation.json";
import ko from "./locales/ko/translation.json";
import lo from "./locales/lo/translation.json";
import lv from "./locales/lv/translation.json";
import lt from "./locales/lt/translation.json";
import mk from "./locales/mk/translation.json";
import ms from "./locales/ms/translation.json";
import mn from "./locales/mn/translation.json";
import nb from "./locales/nb/translation.json";
import fa from "./locales/fa/translation.json";
import pl from "./locales/pl/translation.json";
import pt from "./locales/pt/translation.json";
import ro from "./locales/ro/translation.json";
import ru from "./locales/ru/translation.json";
import sr from "./locales/sr/translation.json";
import sk from "./locales/sk/translation.json";
import sl from "./locales/sl/translation.json";
import sv from "./locales/sv/translation.json";
import tl from "./locales/tl/translation.json";
import te from "./locales/te/translation.json";
import th from "./locales/th/translation.json";
import tr from "./locales/tr/translation.json";
import uk from "./locales/uk/translation.json";
import vi from "./locales/vi/translation.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
      ml: { translation: ml },
      es: { translation: es },
      sq: { translation: sq },
      am: { translation: am },
      az: { translation: az },
      eu: { translation: eu },
      bn: { translation: bn },
      bs: { translation: bs },
      bg: { translation: bg },
      my: { translation: my },
      ca: { translation: ca },
      zh: { translation: zh },
      hr: { translation: hr },
      cs: { translation: cs },
      da: { translation: da },
      nl: { translation: nl },
      et: { translation: et },
      fi: { translation: fi },
      fr: { translation: fr },
      gl: { translation: gl },
      ka: { translation: ka },
      de: { translation: de },
      el: { translation: el },
      gu: { translation: gu },
      he: { translation: he },
      hi: { translation: hi },
      hu: { translation: hu },
      id: { translation: id },
      it: { translation: it },
      ja: { translation: ja },
      km: { translation: km },
      ko: { translation: ko },
      lo: { translation: lo },
      lv: { translation: lv },
      lt: { translation: lt },
      mk: { translation: mk },
      ms: { translation: ms },
      mn: { translation: mn },
      nb: { translation: nb },
      fa: { translation: fa },
      pl: { translation: pl },
      pt: { translation: pt },
      ro: { translation: ro },
      ru: { translation: ru },
      sr: { translation: sr },
      sk: { translation: sk },
      sl: { translation: sl },
      sv: { translation: sv },
      tl: { translation: tl },
      te: { translation: te },
      th: { translation: th },
      tr: { translation: tr },
      uk: { translation: uk },
      vi: { translation: vi },
    },
    fallbackLng: "en",
    debug: false,
    saveMissing: true,
    missingKeyHandler: (lng, ns, key, fallbackValue) => {
      if (useFeatureStore.getState().isFeatureEnabled("missing_translation")) {
        fetch("http://localhost:3001/missing", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ key, lng, ns }),
        }).catch(() => {}); // Ignore errors if server is not running
      }
    },
    interpolation: {
      escapeValue: false,
    },
  });

const rtlLanguages = ["ar", "fa", "he"];

const setDirection = (lang) => {
  if (!lang) return;
  const baseLang = lang.split("-")[0];
  const dir = rtlLanguages.includes(baseLang) ? "rtl" : "ltr";
  document.documentElement.dir = dir;
  document.documentElement.lang = baseLang;
};

// Set direction immediately since i18n might initialize synchronously
setDirection(i18n.language);

i18n.on("languageChanged", (lng) => {
  setDirection(lng);
});

export default i18n;
